<template>
    <form @submit.prevent="feedback.post(requestUrl, {
        preserveScroll: true,
    })">
        <select v-model="feedback.reason" class="rounded border-black w-full p-3 my-3 text-lg capitalize" required>
            <option disabled value="">Select a reason</option>
            <option v-for="item in reasons" :value="item">{{ item.replaceAll('_', ' ') }}</option>
        </select>

        <textarea
            v-model="feedback.comment"
            placeholder="Additional comments"
            class="rounded border-black w-full p-3 my-3 placeholder-black text-lg"
            rows="7"
            required
        ></textarea>

        <p class="my-4 text-dark text-lg">Let us know the best way and time to contact you</p>

        <select
            v-model="feedback.contact"
            class="rounded border-black w-full p-3 my-3 text-lg capitalize"
            required
        >
            <option disabled value="">Select a contact method</option>
            <option v-for="item in contact" :value="item">{{ item }}</option>
        </select>

        <select
            v-if="feedback.contact == 'telephone' || feedback.contact == 'both'"
            v-model="feedback.time"
            class="rounded border-black w-full p-3 my-3 text-lg capitalize"
            required
        >
            <option disabled value="">Select a time</option>
            <option v-for="item in time" :value="item">{{ item }}</option>
        </select>

        <input-recaptcha v-model="feedback.recaptcha" ref="recatpcha"></input-recaptcha>

        <input-error v-if="feedback.errors.recaptcha">
            {{ feedback.errors.recaptcha }}
        </input-error>

        <app-button type="submit" class="mt-8" :loading="feedback.processing">Submit feedback</app-button>
    </form>
</template>
<script>
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import AppNavbar from "@/Components/AppNavbar.vue";
import AppTitle from "@/Components/AppTitle.vue";
import InputError from "@/Components/Forms/Inputs/InputError.vue";
import InputRecaptcha from "@/Components/Forms/Inputs/InputRecaptcha.vue";
import AppButton from "@/Components/AppButton.vue";
import AppPoweredBy from "@/Components/AppPoweredBy.vue";
import AppCard from "@/Components/AppCard.vue";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";

export default {
    components: {
        AppTitle,
        AppNavbar,
        InputRecaptcha,
        AppButton,
        InputError,
        AppPoweredBy,
        AppCard
    },
    props: {
        product: Object,
        fitterIdentifier: String,
        productExternalIdentifier: String,
        recaptcha: Object,
        website: Object, // The website the user has come from
        user: Object,
        rating: [Number, String],
        requestUrl: {
            type: String,
            default: '/feedback'
        },
        orderReference: String,
        reasons: Array,
        contact: Array,
        time: Array
    },
    data() {
        return {
            feedback: useForm({
                product_id: this.fitterIdentifier ?? (this.productExternalIdentifier ?? null),
                website_id: this.website ? this.website.id : null,
                name: this.user?.name ?? "",
                email: this.user?.email ?? "",
                reason: '',
                comment: '',
                contact: '',
                rating: this.rating,
                recaptcha: null,
                time: '',
                reference: this.orderReference
            })
        }
    },
    computed: {
        siteName() {
            return usePage().props.value.config.name;
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
